import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=2397d3a6&scoped=true&"
import script from "./MiniCart.ts?vue&type=script&lang=ts&"
export * from "./MiniCart.ts?vue&type=script&lang=ts&"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=2397d3a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2397d3a6",
  null
  
)

export default component.exports